<template>
  <div class="whiteBox whiteBoxDashboard workspace_notPaid">
    <template v-if="isAdmin">
      Subscription expired, to create new subscription please go to
      <router-link v-bind:to="workspaceId+'/billing'">
        workspace settings
      </router-link>
    </template>
    <template v-else>
      Subscription expired, to create new subscription
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _get from 'lodash.get';

export default {
  props: ['isAdmin'],
  data() {
    return {
      userLogoSrc: ''
    };
  },
  computed: {
    ...mapState(['currentWorkspace']),
    workspaceId: function(){
      return this.$router.currentRoute.params.workspaceId || this.allWorkspaces[0];
    }
  },

  methods: {},
  mounted() {}
};
</script>

<style scoped></style>
